import { faXmark } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { DSButton } from "@scribenote/design-system/molecules";
import moment from "moment";
import React from "react";
import { useNavigate } from "react-router";

import { Thumbnail } from "./Thumbnail";
import Twemoji from "../../Twemoji";

export function AttachmentsPreview({
  attachments = [],
  attachmentPreviewText,
  selectedAttachments,
  isForPatientProfile,
  isCompactView,
  patientUUID,
  emptyStateText,
  onDelete,
  handleAttachmentClick = (attachment) => {
    window.open(attachment.fileLink, "_blank");
  },
}) {
  const navigate = useNavigate();

  function renderViewAllAttachments() {
    if (patientUUID && isForPatientProfile) {
      return (
        <div className="flex justify-center mt-sm">
          <DSButton
            variant="secondary"
            onClick={() => {
              navigate(`/notebook/${patientUUID}/attachments`);
            }}
          >
            View All Attachments...
          </DSButton>
        </div>
      );
    }
  }

  function renderEmptyState() {
    const textClassName =
      "text-center text-xs md:text-sm text-secondary my-md";
    return (
      <div
        className={`flex flex-1 items-center justify-center overflow-y-auto p-2 ${
          isCompactView ? "h-10" : "h-32"
        }`}
      >
        {emptyStateText ? (
          <h5 className={textClassName}>{emptyStateText}</h5>
        ) : (
          <h5 className={textClassName}>
            Looks like you have no attachments for this patient yet.
            Try uploading one in a note or on the patient&apos;s
            attachments page!
          </h5>
        )}
      </div>
    );
  }

  function renderListOfAttachments() {
    return (
      <div
        className={`${
          isCompactView ? "h-32" : "h-44"
        } overflow-y-auto`}
        data-testid="attachments-list"
      >
        <div className="flex flex-row pb-sm px-xs flex-wrap">
          {attachments.map((attachment, index) => {
            let isAttachmentSelected = false;
            if (
              selectedAttachments &&
              (attachment.uuid === selectedAttachments[0]?.uuid ||
                attachment.uuid === selectedAttachments[1]?.uuid)
            ) {
              isAttachmentSelected = true;
            }
            return (
              <div
                key={index}
                className="flex flex-col items-center m-md"
                data-testid={`attachment-file-name-${attachment.fileName}`}
              >
                <div className="relative max-w-fit w-full hover:scale-105 transition-transform">
                  <Thumbnail
                    attachment={attachment}
                    handleAttachmentClick={handleAttachmentClick}
                    isAttachmentSelected={isAttachmentSelected}
                  />
                  {onDelete && (
                    <button
                      onClick={(e) => {
                        e.stopPropagation();
                        onDelete(attachment.uuid);
                      }}
                      className="absolute -top-2 -right-2 z-control bg-danger hover:bg-danger/80 text-white rounded-full w-5 h-5 flex items-center justify-center transition-colors"
                      data-testid={`delete-attachment-${attachment.uuid}`}
                    >
                      <FontAwesomeIcon
                        icon={faXmark}
                        className="text-[10px]"
                      />
                    </button>
                  )}
                </div>
                <h5 className="text-xs text-center mt-xs line-clamp-1 px-xs max-w-[90px]">
                  {attachment.fileName}
                </h5>
                <span className="text-[10px] text-secondary">
                  {moment(attachment.createdAt).format("MMM Do YYYY")}
                </span>
              </div>
            );
          })}
        </div>
      </div>
    );
  }

  return (
    <div className="relative shadow-primary rounded-standard pt-lg">
      <div className="absolute top-0 z-base w-full items-center px-sm pb-sm pt-sm rounded-t-standard">
        <h4
          className={`${
            isCompactView ? "text-sm" : "text-base"
          } text-center text-primary pb-sm`}
        >
          <Twemoji emoji={"📂"} /> {attachmentPreviewText || "Files"}
        </h4>
      </div>
      {attachments?.length
        ? renderListOfAttachments()
        : renderEmptyState()}

      {renderViewAllAttachments()}
    </div>
  );
}
